/**
 * Auth0 Configuration
 * Environment-based configuration for Auth0 SPA integration
 * Supports TEST and PRODUCTION environments
 */

// Get environment mode (default to TEST if not PRODUCTION)
const envMode = process.env.REACT_APP_ENV_MODE?.toUpperCase();
const isProduction = envMode === 'STAGING';
const environment = isProduction ? 'STAGING' : 'TEST';

console.log(`Using ${environment} environment for Auth0 client configuration`);

// Build environment-specific variable names
const domainVar = `REACT_APP_${environment}_AUTH0_DOMAIN`;
const clientIdVar = `REACT_APP_${environment}_AUTH0_CLIENT_ID`;
const audienceVar = `REACT_APP_${environment}_AUTH0_AUDIENCE`;
const organizationVar = `REACT_APP_${environment}_AUTH0_ORGANIZATION`;
const connectionVar = `REACT_APP_${environment}_AUTH0_CONNECTION`;

const auth0Config = {
  domain: process.env[domainVar],
  clientId: process.env[clientIdVar],
  audience: process.env[audienceVar],
  redirectUri: `${window.location.origin}/login/callback`,
  scope: 'openid profile email',

  // Cache settings
  cacheLocation: 'localstorage', // Use localStorage to persist tokens across page reloads
  useRefreshTokens: true,

  // Custom login flow settings
  skipRedirectCallback: false, // Allow manual handling
  loginRequired: false, // Don't auto-redirect to login

  // Optional settings
  organization: process.env[organizationVar],
  connection: process.env[connectionVar],

  // API settings
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8010/v1',

  // Environment info
  environment: environment,
};

// Validate required configuration
const requiredConfig = ['domain', 'clientId', 'audience'];
const missingConfig = requiredConfig.filter(key => !auth0Config[key]);

if (missingConfig.length > 0) {
  console.error(`Missing required Auth0 configuration for ${environment} environment:`, missingConfig);
  console.error('Please check your environment variables:');
  missingConfig.forEach(key => {
    const envVar = `REACT_APP_${environment}_AUTH0_${key.toUpperCase()}`;
    console.error(`- ${envVar}`);
  });
}

export default auth0Config;

// Helper function to check if Auth0 is properly configured
export const isAuth0Configured = () => {
  return requiredConfig.every(key => auth0Config[key]);
};

// Export individual config values for convenience
export const {
  domain,
  clientId,
  audience,
  redirectUri,
  scope,
  cacheLocation,
  useRefreshTokens,
  organization,
  connection,
  apiBaseUrl
} = auth0Config;